import { graphql } from '@apollo/react-hoc';
import gql from 'graphql-tag';
import get from 'lodash/get';
import config from '../../../../config';

const DEFAULT_LOCALE = config('defaultLocale');

const withRelatedWorks = Component =>
  graphql(
    gql`
  query withRelatedWorks($workId: ID!, $locale: String!, $blacklist: String, $method: guru_RelatedWorksMethod) {
    relatedWorks: unfilteredRelatedWorks(workId: $workId, limit: 100, method: $method, blacklist: $blacklist) {
      work(locale: $locale) {
        ...${Component.displayName}
      }
    }
  }
  ${Component.fragment}
`,
    {
      props: ({
        data: { relatedWorks, loading, error, refetch },
        ownProps
      }) => {
        const userId = get(ownProps, 'userInfo.userId');

        return {
          ...ownProps,
          loading,
          error,
          refetch,
          items: (relatedWorks || []).filter(({ work }) => {
            if (!work) return false;

            const artistId = get(work, 'artistId');

            const workIsMature = get(work, 'matureContent', false);
            const userOwnsWork =
              artistId && userId && artistId.toString() === userId;

            return !workIsMature && !userOwnsWork;
          })
        };
      },
      skip: ({ workId }) => !workId,
      options: props => {
        const locale = get(props, 'userInfo.locale', DEFAULT_LOCALE);

        return {
          variables: {
            blacklist: config('blacklistName'),
            workId: props.workId,
            method: 'default',
            locale
          },
          errorPolicy: 'all',
          ssr: false
        };
      }
    }
  )(Component);

withRelatedWorks.displayName = 'withRelatedWorks';

export default withRelatedWorks;
